import { useState, useEffect } from "react"

import { Credentials } from "../constants";

export const signIn = async () => {
   const response = await fetch(`${Credentials.endpoint}/users/sign_in`, {
      method: 'POST',
      body: JSON.stringify({
         user: {
            username: Credentials.user,
            password: Credentials.password,
         },
      }),
      headers: {
         'Content-Type': 'application/json',
      },
   });

   const data: { auth_token: string; } = await response.json()

   return data
}


export const useBmsAuth = () => {
   const [token, setToken] = useState(null)
   const [loading, setLoading] = useState(false)
   useEffect(() => {
      const getToken = async () => {
         if (token || loading) return;
         setLoading(true)
         const data = await signIn()
         setToken(data.auth_token)
         setLoading(false)
      }
      console.log('render')
      getToken()
   }, [])
   return token
}